module.exports = new __parcel__URL__("main-hero.953d2108.jpg").toString();